import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import axios from "axios";
import { ApiUrl } from '../Constants/Weburl'


export default function OtheruserDetails() {
  const [users, setUsers] = useState([]);

  const { id } = useParams();

  console.log("id users", id);


  useEffect(() => {
    fetchSpecificusers()
  }, [id])

  const fetchSpecificusers = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      const res = await axios.get(
        `${ApiUrl}api/auth/specificusers/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("specific user response", res.data.data);
      setUsers(res.data.data);
    }
    catch (e) {
      console.log("error", e);
    }
  };
  // return (
  //   <div className="other-details-card">

  //     <h3 className="section-title">OTHER DETAILS</h3>

  //     <div className="detail-row toggle-row">
  //       <span>Freeze :</span>
  //       <label className="switch">
  //         <input type="checkbox" />
  //         <span className="slider"></span>
  //       </label>
  //     </div>

  //     <div className="detail-row toggle-row">
  //       <span>Moderator :</span>
  //       <label className="switch">
  //         <input type="checkbox" />
  //         <span className="slider"></span>
  //       </label>
  //     </div>

  //     <div className="detail-row">
  //       <span>Identity :</span>
  //       <p>{users?.email}</p>
  //     </div>

  //     <div className="detail-row">
  //       <span>Email :</span>
  //       <p></p>
  //     </div>

  //     <div className="detail-row">
  //       <span>Phone :</span>
  //       <p>{users?.phone}</p>
  //     </div>

  //     <hr />

  //     <div className="detail-row">
  //       <span>Last Opened :</span>
  //       <p>{new Date(users?.updatedAt).toLocaleDateString("en-IN")}</p>
  //     </div>

  //     <div className="detail-row">
  //       <span>Log-in :</span>
  //       <p>{users?.provider}</p>
  //     </div>

  //     <div className="detail-row">
  //       <span>Device OS :</span>
  //       <p>{users?.deviceOS}</p>
  //     </div>

  //     <div className="detail-row token-row">
  //       <span>Device Token :</span>
  //       <p>
  //         CCAQvbxesM-G7IKtxk5bG5APA9IbErigmNgHcli9Ck3
  //         KZbUH33ltWmWGXk4MVhpPbJPFjNDL
  //         MYFo7OL2WApLbZFZQ7Tv5urCWOHndE
  //         Mc5fgeAS0u4BfJGsFFjGB2MrJYcVaph
  //         Oj3tCA
  //       </p>
  //     </div>

  //     <hr />

  //     <div className="detail-row">
  //       <span>Country :</span>
  //       <p>{users?.countryCode}</p>
  //     </div>

  //     <div className="detail-row">
  //       <span>Region :</span>
  //       <p>{users?.address}</p>
  //     </div>

  //     <div className="detail-row">
  //       <span>City :</span>
  //       <p></p>
  //     </div>

  //     <div className="detail-row">
  //       <span>Latitude :</span>
  //       <p>{users?.posts?.latitude}</p>
  //     </div>

  //     <div className="detail-row">
  //       <span>Longitude :</span>
  //       <p>{users?.posts?.longitude}</p>
  //     </div>

  //     <hr />

  //     <div className="detail-row">
  //       <span>Who Can View Post :</span>
  //       <p>Everyone</p>
  //     </div>

  //     <div className="detail-row">
  //       <span>Show Following :</span>
  //       <p>Yes</p>
  //     </div>

  //     <div className="detail-row">
  //       <span>Receive Message :</span>
  //       <p>Yes</p>
  //     </div>


  //   </div>
  // );
  return (
    <div className="other-details-card">
      
      <div className="section-title">
      <h3>OTHER DETAILS</h3>
      </div>

      <div className="od-columns">

        {/* LEFT - 9 details */}
        <div className="od-col">
          <div className="detail-row toggle-row">
            <span>Freeze :</span>
            <label className="switch">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </div>

          <div className="detail-row toggle-row">
            <span>Moderator :</span>
            <label className="switch">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </div>

          <div className="detail-row">
            <span>Identity :</span>
            <p>{users?.email}</p>
          </div>

          <div className="detail-row">
            <span>Email :</span>
            <p></p>
          </div>

          <div className="detail-row">
            <span>Phone :</span>
            <p>{users?.phone}</p>
          </div>

          <hr />

          <div className="detail-row">
            <span>Last Opened :</span>
            <p>{new Date(users?.updatedAt).toLocaleDateString("en-IN")}</p>
          </div>

          <div className="detail-row">
            <span>Log-in :</span>
            <p>{users?.provider}</p>
          </div>
        </div>

        {/* RIGHT - 8 details */}
        <div className="od-col">

          <div className="detail-row">
            <span>Device OS :</span>
            <p>{users?.deviceOS}</p>
          </div>

          <div className="detail-row token-row">
            <span>Device Token :</span>
            <p>
             {users?.fcmToken}
            </p>
          </div>
          
          <div className="detail-row">
            <span>Country :</span>
            <p>{users?.countryCode}</p>
          </div>

          {/* <div className="detail-row">
            <span>Region :</span>
            <p>{users?.address}</p>
          </div>

          <div className="detail-row">
            <span>City :</span>
            <p></p>
          </div>

          <div className="detail-row">
            <span>Latitude :</span>
            <p>{users?.posts?.latitude}</p>
          </div>

          <div className="detail-row">
            <span>Longitude :</span>
            <p>{users?.posts?.longitude}</p>
          </div> */}

          {/* <hr /> */}

          <div className="detail-row">
            <span>Who Can View Post :</span>
            <p>Everyone</p>
          </div>

          <div className="detail-row">
            <span>Show Following :</span>
            <p>Yes</p>
          </div>

          <div className="detail-row">
            <span>Receive Message :</span>
            <p>Yes</p>
          </div>
        </div>

      </div>
    </div>
  );


}
